import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  required,
  TopToolbar,
  ShowButton,
  ListButton
} from 'react-admin'
import { Box, Typography } from '@mui/material'

const ProviderGroupEditActions = () => (
  <TopToolbar>
    <ListButton />
    <ShowButton />
  </TopToolbar>
)

export const ProviderGroupEdit = (props) => {
  return (
    <Edit actions={<ProviderGroupEditActions />} {...props} title="Edit Provider Group">
      <SimpleForm>
        <Box width="100%">
          <Typography variant="h6" gutterBottom>Provider Group Details</Typography>
          <Box display="flex" gap={2}>
            <TextInput source="name" label="Group Name" validate={[required()]} fullWidth />
            <TextInput source="adminName" label="Admin Name" fullWidth />
            <TextInput source="adminEmail" label="Admin Email" type="email" fullWidth />
            <TextInput source="shopifyCompanyName" label="Shopify Company Name" fullWidth />
            <BooleanInput source="splitInvoiceByLocation" label="Split Invoice by Location" />
            <BooleanInput source="provideReplacementCoupons" label="Provide Replacement Coupons" defaultValue={false} />
          </Box>
        </Box>
      </SimpleForm>
    </Edit>
  )
}

export default ProviderGroupEdit
